import { Select } from "@mantine/core";
import { DECISION_OPTIONS } from "../Todos.constants";
import type { TodoUserDecision } from "../Todos.types";
import "./TodoSwitch.scss";

interface TodoSwitchProps {
  userDecision: TodoUserDecision;
  finished: boolean;
  onChangeUserDecision: (decision: TodoUserDecision, finished: boolean) => void;
}

function TodoSwitch({
  userDecision,
  finished,
  onChangeUserDecision
}: TodoSwitchProps) {
  const decisionDropdownData = DECISION_OPTIONS.map((decision) => ({
    value: `${decision.decision}-${decision.finished}`,
    label: decision.displayName
  }));

  function handleDecisionChange(decisionValue: string | null) {
    if (!decisionValue) {
      return;
    }

    const decisionValueParts = decisionValue.split("-");
    const selectedDecision = decisionValueParts[0];
    const selectedFinished = decisionValueParts[1] === "true";

    const selectedDecisionItem = DECISION_OPTIONS.find(
      (decision) =>
        decision.decision === selectedDecision &&
        decision.finished === selectedFinished
    );

    if (selectedDecisionItem?.decision) {
      onChangeUserDecision(
        selectedDecisionItem.decision,
        selectedDecisionItem.finished
      );
    }
  }

  return (
    <Select
      className={`TodoSwitch decision-${userDecision}-${finished}`}
      data={decisionDropdownData}
      value={`${userDecision}-${finished}`}
      w={220}
      onChange={handleDecisionChange}
    />
  );
}

export { TodoSwitch, TodoSwitchProps };
